import React from 'react';
import { Button } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import styles from './OverviewWelcomeMessage.module.less';
import { trackButtonClick } from '../../../lib/fpti';
import isAbsolutePath from '../../../util/isAbsolutePath';
import Image from '../../../components/Image';

const OverviewWelcomeMessage = ({ ecmContent }) => {
  const { content, contentJson } = ecmContent;
  const { buttonConfig, imageUrl, demoButton, imageConfig } = contentJson;
  const navigate = useNavigate();

  const handleNavigation = (url) => {
    if (isAbsolutePath(url)) {
      if (url.includes('/studio')) {
        window.open(url, '_self', 'popup=false');
      } else {
        window.open(url);
      }
    } else {
      navigate(url);
    }
  };

  return (
    <div className={styles.welcome_message_container}>
      <div
        className={styles.welcome_message_html}
        data-testid="overview-title"
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
      <div className={styles.buttons_container}>
        {demoButton && (
          <Button
            onClick={() => {
              trackButtonClick('View Demo', demoButton.url);
              handleNavigation(demoButton.url);
            }}
          >
            {demoButton.label}
          </Button>
        )}
        {buttonConfig && (
          <Button
            onClick={() => {
              trackButtonClick(buttonConfig.label, buttonConfig.url);
              handleNavigation(buttonConfig.url);
            }}
          >
            {buttonConfig.label}
          </Button>
        )}
      </div>
      <div className={styles.view_demo_container}>
        {(imageUrl || imageConfig) && <Image imageConfig={imageConfig || { src: imageUrl }} />}
      </div>
    </div>
  );
};

OverviewWelcomeMessage.propTypes = { ecmContent: PropTypes.object };
OverviewWelcomeMessage.defaultProps = {
  ecmContent: { content: '', contentJson: { buttonConfig: null, imageUrl: '', demoUrl: '' } }
};

export default OverviewWelcomeMessage;
